"use client";

import { useEffect, useState } from "react";

const getRoot = () =>
  (document.querySelector('.mapleos-root:not([data-mapleos-portal-theme="true"])') as HTMLElement | null) ||
  (document.querySelector('.mapleos-root') as HTMLElement | null) ||
  document.documentElement;

export default function useOsDark(): boolean {
  const [isDark, setIsDark] = useState<boolean>(() => getRoot().classList.contains("dark"));

  useEffect(() => {
    const root = getRoot();
    const update = () => setIsDark(root.classList.contains("dark"));
    update();

    const obs = new MutationObserver(update);
    obs.observe(root, { attributes: true, attributeFilter: ["class"] });

    return () => obs.disconnect();
  }, []);

  return isDark;
}
